import { Container } from "@mantine/core";
import { ProgressProps } from "@mantine/core";
import ColorStrip from "../ColorStrip";
import classes from "./index.module.css";
import Logo from "@/components/Icons/Logo";
import { Close } from "@/components/Icons";
import { ProgressBar } from "@/components/Header/ProgressBar";
import { useParams } from "next/navigation";
import { ReactNode } from "react";
import { openContextModal } from "@mantine/modals";
import ActionIcon from "../ActionIcon";
import { useTranslation } from "@/i18n/client";
import { Save1 } from "@/components/Icons";
import Button from "../Button";
import Text from "@/components/Text";
import { InfoBanner } from "./InfoBanner";

interface HeaderProps {
  withColorStrip?: boolean;
  progressProps?: ProgressProps;
  dropdown?: ReactNode;
  withSaveContract?: boolean;
  withInfoBanner?: boolean;
  bonus?: boolean;
  noAssignedBonus?: boolean;
  onClose?: () => void;
}

const Header = ({
  dropdown,
  withColorStrip = false,
  progressProps,
  withSaveContract = true,
  withInfoBanner = false,
  noAssignedBonus = false,
  onClose,
}: HeaderProps) => {
  const { t } = useTranslation("components");
  const params = useParams();

  return (
    <>
      {withColorStrip && <ColorStrip />}
      <div className={classes.header}>
        <Container size={1400} className={classes.container}>
          <div className={classes.left}>
            <Logo className={classes.logo} />
          </div>
          <div className={classes.right}>
            <div className={classes.dropdownContainer}>{dropdown}</div>
            {withSaveContract && !onClose && (
              <Button
                leftSection={<Save1 fontSize="1.5rem" fill="#262626" />}
                variant="white"
                onClick={() => openContextModal({ modal: "saveProcess", innerProps: { uuid: String(params.id) } })}
                justify="center"
                className={classes.saveButton}>
                <Text variant="reading_medium" color="neutral.9">
                  {t("Header.save")}
                </Text>
              </Button>
            )}
            {onClose && (
              <ActionIcon aria-label={t("Header.close")} onClick={onClose} variant="default">
                <Close />
              </ActionIcon>
            )}
          </div>
        </Container>
      </div>
      <ProgressBar progressProps={progressProps} />
      {withInfoBanner && <InfoBanner noAssignedBonus={noAssignedBonus} />}
    </>
  );
};

export default Header;
